import { __awaiter, __generator } from "tslib";
export var storeDataString = function (key, value) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        // saving error
      }
      return [2 /*return*/];
    });
  });
};
export var storeDataObject = function (key, value) {
  return __awaiter(void 0, void 0, void 0, function () {
    var jsonValue;
    return __generator(this, function (_a) {
      try {
        jsonValue = JSON.stringify(value);
        localStorage.setItem(key, jsonValue);
      } catch (e) {
        // saving error
      }
      return [2 /*return*/];
    });
  });
};
export var getDataString = function (key) {
  return __awaiter(void 0, void 0, void 0, function () {
    var value;
    return __generator(this, function (_a) {
      try {
        value = localStorage.getItem(key);
        if (value !== null) {
          return [2 /*return*/, value];
        }
      } catch (e) {
        // error reading value
      }
      return [2 /*return*/, null];
    });
  });
};
export var getDataObject = function (key) {
  return __awaiter(void 0, void 0, void 0, function () {
    var jsonValue;
    return __generator(this, function (_a) {
      try {
        jsonValue = localStorage.getItem(key);
        return [2 /*return*/, jsonValue != null ? JSON.parse(jsonValue) : null];
      } catch (e) {
        // error reading value
      }
      return [2 /*return*/];
    });
  });
};